import React, { useEffect, useState } from 'react'
import { makeStyles, Grid, Typography } from '@material-ui/core'
import NotificationCard from '../../NotificationCard'
import { useStateValue } from 'context/store'
import cloneDeep from 'lodash/cloneDeep'
import moment from 'moment'

const NOTIFICATIONS_BY_DATE = [
   { title: 'Hoy', maxDifferenceDays: 0, notificationsList: [] },
   { title: 'Ayer', maxDifferenceDays: 1, notificationsList: [] },
   {
      title: 'Más de 2 días',
      maxDifferenceDays: 7,
      notificationsList: []
   },
   {
      title: 'Más de 7 días',
      maxDifferenceDays: 15,
      notificationsList: []
   },
   {
      title: '15 días o más',
      maxDifferenceDays: 365,
      notificationsList: []
   }
]

function sortNotificationsSummaryByDate(notificationsSummary) {
   const data = cloneDeep(notificationsSummary)
   const newNotificationsByDate = cloneDeep(NOTIFICATIONS_BY_DATE)
   if (data && data.length) {
      const today = moment()
      data.forEach(notification => {
         const { createdDate } = notification
         const notificationCreatedDate = moment(createdDate, 'DD-MM-YYYY')
         for (let i = 0; i < newNotificationsByDate.length; i++) {
            const { maxDifferenceDays, notificationsList } =
               newNotificationsByDate[i]
            if (
               today.diff(notificationCreatedDate, 'days') <= maxDifferenceDays
            ) {
               notificationsList.push(notification)
               break
            }
         }
      })
   }
   return newNotificationsByDate
}

function NotificationsSummary() {
   const [{ notificationsSummary }] = useStateValue()
   const [notificationsByDate, setNotificationsByDate] = useState([])

   useEffect(() => {
      const arrangedNotifications =
         sortNotificationsSummaryByDate(notificationsSummary)
      setNotificationsByDate(arrangedNotifications)
   }, [notificationsSummary])

   return (
      <>
         {notificationsByDate.map((notificationByDate, index) => (
            <NotificationByDate
               key={index}
               notificationByDate={notificationByDate}
            />
         ))}
      </>
   )
}

export default NotificationsSummary

// --------------

const useNotificationByDateStyles = makeStyles(() => ({
   titleContainer: {
      backgroundColor: '#F4F7FE',
      padding: '8px 20px'
   },
   title: {
      textAlign: 'left',
      font: 'normal normal normal 12px/16px Roboto',
      letterSpacing: 0,
      color: '#3264DC',
      opacity: 1
   }
}))

function NotificationByDate({ notificationByDate }) {
   const classes = useNotificationByDateStyles()
   const { title, notificationsList } = notificationByDate
   return (
      <>
         {notificationsList && !!notificationsList.length && (
            <Grid>
               <Grid className={classes.titleContainer}>
                  <Typography className={classes.title}>{title}</Typography>
               </Grid>
               <Grid>
                  {notificationsList.map(notification => (
                     <NotificationCard
                        isCollapsable={true}
                        key={notification.id}
                        notification={notification}
                     />
                  ))}
               </Grid>
            </Grid>
         )}
      </>
   )
}
